import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import Navbar from "../components/webpage/Navbar";
import Footer from "../components/webpage/Footer";

const SuccessPage = () => {
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Only read & show local info; do NOT call your API here.
    const infoRaw = localStorage.getItem("paymentInfo");
    if (infoRaw) {
      try {
        const info = JSON.parse(infoRaw);
        setPaymentInfo(info);
      } catch {}
      // Clear so refresh/back/forward won't ever duplicate anything
      localStorage.removeItem("paymentInfo");
    }
  }, []);

  const sessionId = params.get("session_id"); // optional: from success_url

  return (
    <Wrapper>
      <Navbar />
      <Content>
        <h2>✅ Płatność zakończona sukcesem</h2>

        {paymentInfo ? (
          <>
            <p><strong>Email:</strong> {paymentInfo.email}</p>
            {paymentInfo.creatorCode && (
              <p><strong>Kod twórcy:</strong> {paymentInfo.creatorCode}</p>
            )}
            <p><strong>Licencja:</strong> {paymentInfo.license}</p>
            {/* displayPrice already contains PLN text */}
            <p><strong>Cena:</strong> {paymentInfo.price}</p>
            <p>
              <strong>Data płatności:</strong>{" "}
              {new Date(paymentInfo.timestamp).toLocaleString("pl-PL")}
            </p>
          </>
        ) : (
          <p>Twoja płatność została przetworzona. Wkrótce wyślemy potwierdzenie na e-mail.</p>
        )}

        {sessionId && (
          <p style={{ marginTop: "0.5rem", fontSize: "0.95rem", color: "#6b7280" }}>
            ID transakcji: {sessionId}
          </p>
        )}

        <button onClick={() => navigate("/")}>Wróć do strony głównej</button>
      </Content>
      <Footer />
    </Wrapper>
  );
};

export default SuccessPage;

const Wrapper = styled.div`
  min-height: 100vh;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  padding: 4rem 2rem;
  text-align: center;
  flex-grow: 1;

  h2 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
    color: #16a34a;
  }

  p {
    margin: 0.5rem 0;
    font-size: 1.1rem;
  }

  button {
    margin-top: 2rem;
    background: #10b981;
    color: white;
    padding: 0.8rem 2rem;
    font-size: 1rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    &:hover { background: #059669; }
  }
`;
